import React, { type CSSProperties } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { getEntitlements } from '@surfline/web-common';

import GoogleDFP from 'components/GoogleDFP';
import convertConditionsBasedAdUnitsToAdTargets from 'utils/conditionsBasedAdUnits';
import { useAppSelector } from 'stores/hooks';
import loadAdConfig from 'utils/adConfig';
import { getConditionsBasedAdUnits } from 'selectors/spot';

import styles from './CamCompanionAd.module.scss';

interface Props {
  adConfigName?: 'camCompanionAd' | 'camCompanionAdBelowCam';
  style?: CSSProperties | undefined;
}

const CamCompanionAd: React.FC<Props> = ({ adConfigName = 'camCompanionAd', style }) => {
  const router = useRouter();
  const { spotId } = router.query;
  const entitlements = useAppSelector(getEntitlements);
  const conditionsBasedAdUnits = useAppSelector(getConditionsBasedAdUnits);
  const conditionsTargets = convertConditionsBasedAdUnitsToAdTargets(conditionsBasedAdUnits);
  const adTargets = [['spotid', spotId], ...conditionsTargets];
  const adConfig = loadAdConfig(adConfigName, adTargets, entitlements);

  return (
    <div
      className={classNames(styles.companionAd, {
        [styles.companionAdBelowCam]: adConfigName === 'camCompanionAdBelowCam',
      })}
      data-testid="cam-companion-ad"
      style={style}
    >
      <GoogleDFP adConfig={adConfig} useUuid />
    </div>
  );
};

export default CamCompanionAd;
